export function currentCompetitionPath() {
  return (window.location.pathname.match(/\/competitions\/.*?\/entries/) || [])[0]
}
export function dealsPath() {
  return window.location.pathname.includes("deals")
}
export function staffPicksPath() {
  return window.location.pathname.includes("staff-picks")
}
export function allArtPath() {
  if (window.location.pathname === "/artworks") return true

  // When we remove the medium filter, some options remain in effect.
  const regex = /^\/artworks\/per\/([^\/]+)\/sort\/([^\/]+)$/
  return regex.test(window.location.pathname)
}
export function trendingArtPath() {
  return window.location.pathname == "/staff-picks/price-range/1000-99999/sort/popular"
}
export function exclusivesPath() {
  return window.location.pathname.includes("exclusives")
}
export function featuredArtPath() {
  return window.location.pathname.includes("featured-art")
}

export function basePath() {
  if (dealsPath()) return "/deals"
  if (staffPicksPath()) return "/staff-picks"
  if (exclusivesPath()) return "/exclusives"
  if (featuredArtPath()) return "/featured-art"

  return currentCompetitionPath() || "/artworks"
}
